import axios from 'axios'
import {Toast} from 'mint-ui';
import {getToken,removeToken} from '@/utils/auth'
import router from '../router'
import {wxloginUrl} from "./wxLoginUrl";
// create an axios instance

let baseUrl = '';
let dev = 'http://192.168.100.2/index.php/mobile/api/v1/';
let product = 'http://www.czgtgs.com/index.php/mobile/api/v1';

process.env.NODE_ENV === 'development' ? baseUrl=dev : baseUrl=product;

const service = axios.create({
    baseURL: baseUrl, // api的base_url
    timeout: 5000 // request timeout
});
// request interceptor
service.interceptors.request.use(config => {
    // Do something before request is sent
    config.headers['Authorization'] = getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    // config.headers['Authorization'] ='111'

    return config
}, error => {
    // Do something with request error
    // console.log(error) // for debug
    Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
    response => response,
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
        //  const res = response.data;
        //     if (res.code !== 20000) {
        //       Message({
        //         message: res.message,
        //         type: 'error',
        //         duration: 5 * 1000
        //       });
        //       // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
        //       if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        //         MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        //           confirmButtonText: '重新登录',
        //           cancelButtonText: '取消',
        //           type: 'warning'
        //         }).then(() => {
        //           store.dispatch('FedLogOut').then(() => {
        //             location.reload();// 为了重新实例化vue-router对象 避免bug
        //           });
        //         })
        //       }
        //       return Promise.reject('error');
        //     } else {
        //       return response.data;
        //     }
    error => {



        // console.log('err:' + error)// for debug

        // console.log(error.response);


        if (error.response == undefined) {


            Toast({
                message: '访问服务器超时，请稍后再试',
                position: 'bottom',
                duration: 5000
            })

            return Promise.reject(error)
        }
        //
        //
        const errorCode = error.response.status;
        //   if (errorCode==401) {
        //
        //       Message({
        //           message: '登录失效，请重新登录',
        //           type: 'error',
        //           duration: 5 * 1000
        //       });
        //
        //       this.$router.push({
        //           name:'login'
        //       });
        //
        //       return Promise.reject(error)
        //
        //
        //   }
        //
        //   if (errorCode==429) {
        //
        //       Message({
        //           message: '系统繁忙，请稍后重试',
        //           type: 'error',
        //           duration: 5 * 1000
        //       });
        //
        //       return Promise.reject(error)
        //
        //
        //   }
        //
        //
        //   if (errorCode==502) {
        //
        //       Message({
        //           message: '服务器正在维护，请稍后重试',
        //           type: 'error',
        //           duration: 5 * 1000
        //       });
        //
        //       return Promise.reject(error)
        //
        //
        //   }
        //

        if (errorCode == 401 && error.response.data.errorCode == 10001) {


            Toast({
                message: '微信登录过期，重新登录中',
                position: 'bottom',
                duration: 5000
            });

            removeToken();

            location.href = wxloginUrl;


            return Promise.reject(error)


        }
        //
        if (error.response.data.errorCode) {

            Toast({
                message: error.response.data.msg,
                position: 'bottom',
                duration: 5000
            })

            return Promise.reject(error)
        }



        // Message({
        //   message: error.message,
        //   type: 'error',
        //   duration: 5 * 1000
        // });
        return Promise.reject(error)
    })

export default service
